import React, { useEffect, useRef, useState } from 'react'
import Login from '../../UI/Cards/FormCard/Login';
import Verification from '../../UI/Cards/FormCard/Verification';
import Register from '../../UI/Cards/FormCard/Register';

import FormCard from '../../UI/Cards/FormCard/FormCard/FormCard';

// import loginImage from "../../../assets/LoginImage.png";
import loginImage from "../../../assets/Portal Login Image/LoginImage.jpeg";


import classes from "./LoginV2.module.css";
import Modal from '../../Modal/Modal';
import SetTag from '../../Modal/ModalLayouts/SetTag';
import InputForm from '../../forms/InputForm';
import { useDispatch, useSelector } from 'react-redux';

import { resetPortalPassword } from "../../../Api Methods/Api"
import { authActions } from '../../../store/auth-Slice';
import ResetPortalPasswordForm from '../../forms/ResetPortalPasswordForm';
import SimpleSingleInputForm from '../../forms/SimpleSingleInputForm';
import { useNavigate } from "react-router-dom";
import { uiActions } from '../../../store/ui-slice';
import check from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import cross from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import Button1 from '../../UI/Button/Button1';
import mixpanel from 'mixpanel-browser';

const LoginPage = () => {


    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();
    const ModalDialogPopup = useRef();
    const [modalComponent, setModalComponent] = useState()
    const [title, setTitle] = useState("")

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    const HandleShowPopupModal = () => {
        ModalDialogPopup.current.open();
    }

    const HandleClosePopupModal = () => {
        ModalDialogPopup.current.close();
    }



    //---------------------------------------------------------------------------------------------

    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);

    const apiData = {
        token,
        client
    }

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleOnFormSuccess = async (email) => {
        const response = await resetPortalPassword(apiData, email, dispatch)
        if (response.data.success) {
            HandleCloseModal();
            setTitle("Success")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={classes.ModalIcon} src={check}></img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color:"#858585"}}>We've sent you an email with instructions on how to reset your password</h3>
                    </div>   
                    <br></br>
                    <br></br>
                    <div>
                        <br></br>
                        <Button1 onClick={HandleClosePopupModal} style={{width:"100%"}}>Close</Button1>
                    </div>
                </div>
            )
            HandleShowPopupModal()

        } else {
            HandleCloseModal()
            setTitle("Error")
            //attempted password, failed
            mixpanel.track(
                "Attempted password reset",{
                    user: email
                }
            )
            
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={classes.ModalIcon} src={cross}></img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color:"#858585"}}>We're having trouble finding an authorised portal account with that email address, please contact your administrator</h3>
                    </div>   
                    <br></br>
                    <br></br>
                    <div>
                        <br></br>
                        <Button1 onClick={HandleClosePopupModal} style={{width:"100%"}}>Close</Button1>
                    </div>
                </div>
            )

            HandleShowPopupModal();
        }
    }

    return (
        <>

            <Modal ref={ModalDialogPopup} title={title} modalName={"Login"} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <Modal ref={ModalDialog} title={"Reset Password"} modalName={"Login"} HandleShowModal={HandleShowModal}>
                <SimpleSingleInputForm isInputEmail={true} placeholder={"Please enter your email address"} label={"Please enter your email to reset your password"} submitButtonText={"Reset Password"} handleOnFormSuccess={handleOnFormSuccess} />
            </Modal>

            <div className={classes["page-layout"]}>

                <div className={classes.container} >
                    <img className={classes.imageContainer} src={loginImage} loading={'eager'} />

                    <Login className={classes.card} formType="emailPassword" HandleShowModal={HandleShowModal} extraLinks={[{ LinkTextBold: "Activate account", to: "/Register" }]} />
                </div>


            </div>
        </>
    )
}

export default LoginPage